<template>
  <div
    class="purchase-bar"
    :class="{
      'purchase-bar--top': isTopFixed,
      'purchase-bar--bottom': isBottomFixed,
      'purchase-bar--right': isRightFixed && isMqLarger,
      'purchase-bar--mobile': !isMqLarger,
    }"
    :style="{ paddingRight: scrollbarEqualizerMargin }"
    @click="handleClick(false)"
  >
    <div class="purchase-bar__description">
      <div v-if="!isGiftCard" lass="purchase-bar__color">{{ colorName }}</div>
      <div class="purchase-bar__title" :class="{ 'purchase-bar__title--no-border': isGiftCard }">
        {{ name }}
      </div>
    </div>
    <div class="purchase-bar__price-container">
      <div class="purchase-bar__price">{{ productPrice }}</div>
      <div class="purchase-bar__add"><span class="purchase-bar__add-icon icon-plus"></span></div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { scrollSmoothlyToElement } from '@/helpers/scroll'

export default {
  name: 'PurchaseBar',
  props: {
    name: {
      type: String,
      required: true,
    },

    colorName: {
      type: String,
      required: true,
    },

    productPrice: {
      type: String,
      required: true,
    },

    isTopFixed: {
      type: Boolean,
      default: false,
    },

    isBottomFixed: {
      type: Boolean,
      default: false,
    },

    isRightFixed: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      isMqLarger: 'viewport/isMqLarger',
      scrollbarEqualizerMargin: 'page/scrollbarEqualizerMargin',
      isGiftCard: 'product/isGiftCard',
    }),

    scrollTarget() {
      return document.querySelector('.purchase-pod')
    },
  },

  methods: {
    ...mapMutations({ setAllItemsExpanded: 'product/setAllItemsExpanded' }),

    handleClick() {
      if (this.isRightFixed) this.setAllItemsExpanded(false)
      else scrollSmoothlyToElement(this.scrollTarget)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './PurchaseBar';
</style>
